@if (isLoadingCharacter()) {
  <app-loading-component />
} @else {
  <section class="page-card character-sheet">
    <app-back-button-component />

    @if (loadCharacterError()) {
      <p class="validation-text">{{ loadCharacterError() }}</p>
    }

    <div class="head">
      <div class="inputs-container">
        <div class="name-input">{{ character().name || 'Unnamed Character' }}</div>
        <div class="role-input">{{ character().role || character().type || 'Unknown Role' }}</div>
        <div class="character-meta">
          @if (character().nickname) {
            <span><strong>Owner:</strong> {{ character().nickname }}</span>
          }
          @if (character().type) {
            <span><strong>Type:</strong> {{ character().type }}</span>
          }
        </div>
      </div>
      <img
        [src]="character().imageUrl || 'https://37assets.37signals.com/svn/765-default-avatar.png'"
        alt="Character Portrait"
        class="character-image"
      />
    </div>

    <div class="stats-wrapper">
      <div class="stats">
        @for (stat of nonBondStats(); track stat.name) {
          <div class="stat-block">
            <div class="stat-container">
              <div class="stat-value-square">{{ stat.value }}</div>
              <p class="stat-name">{{ stat.name }}</p>
            </div>
          </div>
        }

        <div class="stats-actions">
          <div><strong>Session:</strong> {{ session()?.name || 'Unknown Session' }}</div>
          <div><strong>Universe:</strong> {{ session()?.universeName || 'Unknown Universe' }}</div>
          <div><strong>Campaign:</strong> {{ session()?.campaignName || 'Unknown Campaign' }}</div>
        </div>
      </div>

      @if (character().type === 'Rider' && bondStat(); as bond) {
        <div class="bond-wrapper">
          <div class="bond-stat-sidebar">
            <p class="bond-label">{{ bond.name }} {{ bond.value }}/7</p>
            <div class="bond-squares">
              @for (i of [1, 2, 3, 4, 5, 6, 7]; track i) {
                <div [class.filled]="i <= bond.value" class="bond-square"></div>
              }
            </div>
          </div>
        </div>
      }
    </div>

    @if (character().type === 'Rider') {
      <div class="hp">
        <p class="hp-label">HP {{ hp() }}/{{ calculateHP(character()) }}</p>
        <div class="hp-squares">
          @for (i of getHPArray(); track i) {
            <div [class.filled]="i <= hp()" class="hp-square"></div>
          }
        </div>
      </div>
    }

    <div class="inventory">
      <div class="section-kicker">Equipment</div>
      @if (character().inventory.length) {
        @for (item of character().inventory; track item.name + item.modifier + item.description) {
          <div class="item-row">
            <span class="attack-name">
              {{ item.item }} | {{ item.modifier }} | {{ item.description }}
            </span>
          </div>
        }
      } @else {
        <p class="empty-copy">No items have been recorded for this character yet.</p>
      }
    </div>
  </section>
}
